document.addEventListener("DOMContentLoaded", function () {
  const headerWrapper = document.querySelector(".header-wrapper");
  if (!headerWrapper) return;

  const body = document.body;
  const isHome = body.classList.contains("page-type-index");

  if (isHome) {
    // --- HOMEPAGE HEADER BEHAVIOR ---
    headerWrapper.classList.add("header--transparent");

    // Transparent at top
    window.addEventListener("scroll", () => {
      if (window.scrollY > 50) {
        headerWrapper.classList.remove("header--transparent", "header--hover");
        headerWrapper.classList.add("header--scrolled");
      } else {
        headerWrapper.classList.remove("header--scrolled");
        headerWrapper.classList.add("header--transparent");
      }
    });

    // Hover → white
    headerWrapper.addEventListener("mouseenter", () => {
      if (window.scrollY < 50) {
        headerWrapper.classList.add("header--hover");
        headerWrapper.classList.remove("header--transparent");
      }
    });

    headerWrapper.addEventListener("mouseleave", () => {
      if (window.scrollY < 50) {
        headerWrapper.classList.remove("header--hover");
        headerWrapper.classList.add("header--transparent");
      }
    });

  } else {
    // --- OTHER PAGES HEADER BEHAVIOR ---
    headerWrapper.classList.remove("header--transparent", "header--hover", "header--scrolled");
    headerWrapper.classList.add("header--white");

    // Push page content down so header doesn’t overlap
    const headerHeight = headerWrapper.offsetHeight;
    const main = document.querySelector("main");
    if (main) {
      main.style.paddingTop = headerHeight + "px";
    }

    // Scroll → translucent
    window.addEventListener("scroll", () => {
      if (window.scrollY > 50) {
        headerWrapper.classList.remove("header--white");
        headerWrapper.classList.add("header--scrolled");
      } else {
        headerWrapper.classList.remove("header--scrolled");
        headerWrapper.classList.add("header--white");
      }
    });
  }
});
